import React, { Component } from 'react';
import {connect} from 'react-redux';
import { startLevel } from '../../store/actions'
import WelcomeLayout from '../../styled/WelcomeLayout';
import TitleContainer from '../../styled/TitleContainer';
import TextContainer from '../../styled/TextContainer';
import Container from '../../styled/Container';
import SuperButton from '../SuperButton';
import CaptionContainer from "../../styled/CaptionContainer";
import Share from '../Share';
import { GAGameStart } from "../../analytics.js";

@connect(state => {
  return {
    level: state.game.level
  }
})
class WellCome extends Component {
  render() {
    let title = 'ВИСЕЛИЦА. Игра «Медиазоны» на знание аббревиатур';
    let description = 'Уважаемый пользователь!\n' +
      '\n' +
      'Добро пожаловать во Всероссийскую информационную систему единого лингвопроектирования и центральной автоматизации (ВИСЕЛИЦА).\n' +
      '\n' +
      'Эта система — единственный доступный канал для межведомственного общения после наступления суверенизации российского интернета. \n' +
      '\n' +
      'В базе данных ВИСЕЛИЦА содержится 2976464738 аббревиатур, необходимых для выполнения всех протоколов взаимодействия. Для успешного завершения Вашего обучения в системе Вам необходимо пройти тест на соответствие профессиональным стандартам.\n' +
      '\n' +
      'Перед Вашими глазами будет набор случайно подобранных букв. Из них Вам необходимо будет собрать аббревиатуру по ее описанию. Буквы не обязательно набирать по порядку. \n' +
      '\n' +
      'За каждую неправильную попытку у вас будут отнимать один из десяти баллов. По многочисленным просьбам операторов системы индикатор количества оставшихся баллов для наглядности изображен в виде полицейских погон.\n' +
      '\n' +
      'От полученного результата зависит Ваша карьера.\n' +
      '\n' +
      'Удачи, товарищ.\n';

    if(window) {
      if(window.title) {
        title = window.title
      }
      if(window.description) {
        description = window.description;
      }
    }

    return (
      <WelcomeLayout>
        <Container padding={'0 0 20px 0'}>
          <TitleContainer color={'white'}>{title}</TitleContainer>
        </Container>
        <Container
          padding={'0 0 32px 0'}
        >
          <TextContainer color={'white'} dangerouslySetInnerHTML={{__html: description}} />
        </Container>
        <Container padding={'0 0 45px 0'}>
          <SuperButton
            width={'280px'}
            height={'50px'}
            onClick={() => {
              GAGameStart();
              this.props.dispatch(startLevel(0))}
            }
            >Играть</SuperButton>
        </Container>
        <Container padding={'0 0 30px 0'} direction={'column'}>
          <CaptionContainer color={'white'}>
            Авторы идеи: Максим Литаврин, Александр Бородихин
          </CaptionContainer>
          <CaptionContainer color={'white'}>
            Иллюстратор: Мария Толстова
          </CaptionContainer>
          <CaptionContainer color={'white'}>
            {window.counter || '0 просмотров'}
          </CaptionContainer>
        </Container>
        <Container padding={'0 0 40px 0'}>
          <Share params={[]}/>
        </Container>

      </WelcomeLayout>
    );
  }
}

export default WellCome;
